const baseUrl = "https://static.vivamoselcampo.co/uploads/assets/sponsors-logos";

// Shared sponsor list — used by both AboutUsPage's SectionSponsors (static grid)
// and LandingPage's SponsorsCarouselSection (footer carousel). Logos are served
// from the remote static host (no longer bundled).
const sponsors = [
  {
    name: "Gobierno de Colombia",
    logo: `${baseUrl}/logo-gobierno-de-colombia.png`,
    url: "https://www.presidencia.gov.co/"
  },
  {
    name: "Ministerio de las TIC",
    logo: `${baseUrl}/logo-ministerio-tic.png`,
    url: "https://www.mintic.gov.co"
  },
  { name: "AppsCo", logo: `${baseUrl}/logo-appsco.png`, url: "https://apps.co" },
  { name: "AppsCo Unab", logo: `${baseUrl}/logo-appsco-unab.png` },
  {
    name: "Boyacá es para vivirla",
    logo: `${baseUrl}/logo-boyaca-es-para-vivirla.png`
  },
  {
    name: "Cámara de Comercio de Tunja",
    logo: `${baseUrl}/logo-camara-comercio-tunja.png`,
    url: "https://ccomerciotunja.org.co"
  },
  {
    name: "Fondo Emprender",
    logo: `${baseUrl}/logo-fondo-emprender.png`,
    url: "http://www.fondoemprender.com"
  },
  {
    name: "Fonade",
    logo: `${baseUrl}/logo-fonade.png`,
    url: "http://www.fonade.gov.co"
  },
  {
    name: "Colciencias",
    logo: `${baseUrl}/logo-colciencias.png`,
    url: "http://www.colciencias.gov.co"
  },
  {
    name: "Secretaría Productividad TIC Gobernación Boyacá",
    logo: `${baseUrl}/logo-secretaría-productividad-tic.png`,
    url: "http://www.boyaca.gov.co"
  },
  {
    name: "Servicio Nacional de Aprendizaje SENA",
    logo: `${baseUrl}/logo-sena.png`,
    url: "http://www.sena.edu.co/"
  },
  {
    name: "Universidad de Boyacá",
    logo: `${baseUrl}/logo-uniboyaca.png`,
    url: "https://www.uniboyaca.edu.co/"
  },
  { name: "We-Search Red Comercial", logo: `${baseUrl}/logo-we-search.png` },
  {
    name: "ViveLab Boyacá",
    logo: `${baseUrl}/logo-vivelab-boyaca.png`,
    url: "https://twitter.com/vivelabboyaca"
  }
];

export default sponsors;



// WEBPACK FOOTER //
// ./src/config/sponsors.js